import IndexView from './views/index';
import CaseByIdView from './views/case/_id';

export const views = {
  cm: IndexView,
  caseById: CaseByIdView,
};
